import api from './api';

export interface EmailData {
  weighing_id: number;
  recipients: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  message: string;
  pdf_content: string;
  pdf_filename: string;
}

export interface EmailResponse {
  id: number;
  pesee: number;
  recipients: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  message: string;
  pdf_filename: string;
  status: 'PENDING' | 'SENT' | 'FAILED' | 'DELIVERED' | 'BOUNCED';
  status_display: string;
  sent_at: string | null;
  error_message: string;
  created_at: string;
  updated_at: string;
  recipients_count: number;
  pesee_code: string;
}

export interface EmailListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: EmailResponse[];
}

class EmailService {
  // Envoyer un email
  async sendEmail(emailData: EmailData): Promise<EmailResponse> {
    try {
      const response = await api.post('/weighing/api/emails/send_email/', emailData);
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email:', error);
      throw error;
    }
  }

  // Récupérer tous les emails
  async getEmails(params?: {
    page?: number;
    page_size?: number;
    pesee?: number;
    status?: string;
    search?: string;
    ordering?: string;
  }): Promise<EmailListResponse> {
    try {
      const response = await api.get('/weighing/api/emails/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des emails:', error);
      throw error;
    }
  }

  // Récupérer un email par ID
  async getEmailById(id: number): Promise<EmailResponse> {
    try {
      const response = await api.get(`/weighing/api/emails/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'email:', error);
      throw error;
    }
  }

  // Récupérer les emails d'une pesée
  async getEmailsByWeighing(weighingId: number): Promise<EmailResponse[]> {
    try {
      const response = await api.get(`/weighing/api/emails/by_weighing/?weighing_id=${weighingId}`);
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des emails de la pesée:', error);
      throw error;
    }
  }

  // Renvoyer un email
  async resendEmail(id: number): Promise<EmailResponse> {
    try {
      const response = await api.post(`/weighing/api/emails/${id}/resend/`);
      return response.data.data;
    } catch (error) {
      console.error('Erreur lors du renvoi de l\'email:', error);
      throw error;
    }
  }

  // Supprimer un email
  async deleteEmail(id: number): Promise<void> {
    try {
      await api.delete(`/weighing/api/emails/${id}/`);
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'email:', error);
      throw error;
    }
  }

  // Récupérer les statistiques des emails
  async getEmailStats(): Promise<{
    total: number;
    sent: number;
    failed: number;
    pending: number;
  }> {
    try {
      const response = await api.get('/weighing/api/emails/stats/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  }
}

export default new EmailService();
